import React, { useState, useEffect, useContext } from "react"
import { ButtonGroup, Col, Form, Row } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import Delete from "../../../Components/Modals/DeleteModal"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/DataTable"
import Select from "react-select"
import {
  createBir2037PurchasePayment,
  deleteAdvancePayment,
  deleteBankSP,
  deleteCashSP,
  deleteCheckSP,
  deleteOthersSP,
  getAllSupplierIssuedPayments,
} from "../../../Helpers/apiCalls/Purchases/paySupplierApi"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import {
  isAdmin,
  numberFormat,
  refreshPage,
  selectDropdownStyle,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import "../PurchaseOrders/PurchaseOrders.css"
// import "./PaySuppliers.css"
import DatePicker from "react-datepicker"
import Moment from "moment"
import * as XLSX from "xlsx"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import GenerateBirModal from "../PurchaseOrders/Components/GenerateBirModal"
import { Context } from "../../../Helpers/Utils/Context"

export default function PurchaseIssuedPayment() {
  let navigate = useNavigate()
  const { setDateFrom, setDateTo, dateFilter } = useContext(Context)

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => refreshPage()
  const [showGenerateBirModal, setShowGenerateBirModal] = useState(false)
  const handleShowGenerateBirModal = () => setShowGenerateBirModal(true)
  const handleCloseGenerateBirModal = () => setShowGenerateBirModal(false)
  const [paymentDeets, setPaymentDeets] = useState({ id: "", payment: "" })
  const [selectedRow, setSelectedRow] = useState({})
  const [inactive, setInactive] = useState(true)
  const [paymentList, setPaymentList] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [excelData, setExcelData] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)
  const [suppliers, setSuppliers] = useState([])
  const [summary, setSummary] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState({
    label: "All Suppliers",
    value: "",
  })
  const [filterConfig, setFilterConfig] = useState({
    to: dateFilter.date_to || today,
    from: dateFilter.date_from || aweekago,
    supplier_id: "",
    payment_mode: "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }
  const xlsxHeaders = [
    "DATE ISSUED",
    "SUPPLIER",
    "PAYEE",
    "AMT",
    "PYMNT MODE",
    "INVOICES APPLIED",
    "BANK NAME",
    "DATE ADDED",
    "DOC NO.",
  ]

  async function handleDeleteSP() {
    setIsClicked(true)
    if (selectedRow.doc_no === "Advance Payment") {
      const response = await deleteAdvancePayment(paymentDeets.id)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(() => refreshPage(), 1000)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setTimeout(() => refreshPage(), 1000)
      }
    } else {
      var paymentMode = paymentDeets.payment.split("-")[0].trim()

      if (paymentMode === "cash") {
        const response = await deleteCashSP(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => refreshPage(), 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => refreshPage(), 1000)
        }
      } else if (paymentMode === "check") {
        const response = await deleteCheckSP(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => refreshPage(), 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => refreshPage(), 1000)
        }
      } else if (paymentMode === "bank") {
        const response = await deleteBankSP(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => refreshPage(), 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => refreshPage(), 1000)
        }
      } else if (paymentMode === "other") {
        const response = await deleteOthersSP(paymentDeets.id)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => refreshPage(), 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => refreshPage(), 1000)
        }
      }
    }
  }

  function handleSupplierChange(e) {
    setSelectedSupplier({
      label: e.label,
      value: e.value,
    })
    setFilterConfig((prev) => {
      return { ...prev, supplier_id: e.value }
    })
    // const toFilter = {target: {name: "supplier_id", value: e.value}};
    // handleFilterChange(toFilter);
  }
  //

  async function fetchSuppliers() {
    setSuppliers([])

    const suppliersResponse = await getAllSuppliers()

    if (suppliersResponse.error) {
      TokenExpiry(suppliersResponse)
    } else {
      var suppliers = suppliersResponse.data.data.map((supplier) => {
        var info = supplier
        info.label = supplier.trade_name
        info.value = supplier.id
        return info
      })
      setSuppliers([{ label: "All Suppliers", value: "" }, ...suppliers])
    }
  }

  async function handleGenerateBir2037() {
    setIsClicked(true)

    // yet to be changed
    var response = await createBir2037PurchasePayment(
      selectedRow.id,
      selectedRow.payment_mode
    )
    if (response.data) {
      //extract data from response and then feed to excel
      toast.success("BIR 2307 generated successfully", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
      // handleExcelGeneration(response)
      //after a successfull generation close modal
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      // setTimeout(() => refreshPage(), 1000);
    }
    setIsClicked(false)
  }

  async function fetchAllSupplierPayments() {
    setShowLoader(true)
    setFilteredData([])
    setPaymentList([])
    setTotalItems(0)
    setSummary(0)
    var allData = []
    const response = await getAllSupplierIssuedPayments(filterConfig)
    // console.log(response)
    if (response.data) {
      setSummary(response.data.summary.total_issued_payment)
      //console.log(response.data.summary.total_issued_payment, "total")
      var allPayments = response.data.data.map((data) => {
        var payment = data
        payment.amount = payment.grand_total
          ? numberFormat(payment.grand_total)
          : numberFormat(payment.amount)
        payment.bank_name =
          payment.payment_mode === "bank"
            ? `${payment.bank_from_name || "N/A"} to ${
                payment.bank_to_name || "N/A"
              }`
            : payment.bank_from_name || "N/A"
        payment.date =
          payment.date !== null || payment.date !== "0000-00-00"
            ? Moment(payment.date).format("MMM DD, YYYY")
            : "N/A"
        payment.doc_no = payment.doc_no || "N/A"
        payment.issue_date =
          payment.date !== "0000-00-00"
            ? Moment(payment.date).format("MMM DD, YYYY")
            : "N/A"
        payment.payee = payment.payee || "N/A"
        payment.payment_mode =
          payment.payment_mode === "check"
            ? payment.payment_mode + " - " + payment.check_no
            : payment.payment_mode === "bank"
            ? payment.payment_mode + " - " + payment.reference_no
            : payment.payment_mode
        payment.supplier = payment.supplier || payment.vendor || "N/A"
        allData.push(payment)
        return payment
      })
      var allPayments = allData
        .sort(
          (a, b) =>
            new Date(...a.issue_date?.split("/").reverse()) -
            new Date(...b.issue_date?.split("/").reverse())
        )
        .reverse()
      // setting excel data
      var excel = allPayments.map((bill) => {
        var info = {}
        info.issue_date = bill.issue_date
        info.supplier = bill.supplier
        info.payee = bill.payee
        info.amount = bill.amount
        info.payment_mode = bill.payment_mode
        info.invoice_numbers = `INV. ${bill.invoice_numbers}`
        info.bank_name = bill.bank_name
        info.date = bill.date
        info.doc_no = bill.doc_no
        return info
      })
      setExcelData(excel)
      setPaymentList(allPayments)
      setFilteredData(allPayments)
      setTotalItems(response.data.size)
    }
    setShowLoader(false)
  }

  function handleSelectChange(e, row) {
    if (e.target.value === "edit-ps") {
      navigate(
        "/paysuppliers/edit/" + e.target.id + "/" + e.target.role.split("-")[0]
        // + "/" +
        // e.target.role.split("-")[1]
      )
    } else if (e.target.value === "delete-ps") {
      handleShowDeleteModal()
      setSelectedRow(row)
      setPaymentDeets({ id: e.target.id, payment: e.target.role })
    } else if (e.target.value === "view-ps") {
      if (row.doc_no === "Advance Payment") {
        navigate(
          `/purchaseorders/print/${row.po_no}`
          //    +
          //     e.target.id +
          //     "/" +
          //     e.target.role.split("-")[0]
        )
      } else {
        navigate(
          "/paysuppliers/view/" +
            e.target.id +
            "/" +
            e.target.role.split("-")[0]
          // + "/" +
          // e.target.role.split("-")[1]
        )
      }
    } else if (e.target.value === "generate-bir") {
      handleShowGenerateBirModal()
      setSelectedRow(row)
      // setPaymentDeets({ id: e.target.id, payment: e.target.role })
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        role={`${row.payment_mode}`}
        id={row.id}
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" selected hidden>
          Select
        </option>
        <option value="view-ps" className="color-options">
          View
        </option>
        {/* {isAdmin() && (
                    <option value="edit-ps" className="color-options">
                        Edit
                    </option>
                )} */}
        {isAdmin() && (
          <option value="delete-ps" className="color-red">
            Void Payment
          </option>
        )}
        {isAdmin() && (
          <option value="generate-bir" className="color-red">
            Generate BIR 2307
          </option>
        )}
      </Form.Select>
    )
  }

  // function ViewPayment(row) {
  //     return (
  //         <button
  //             type="button"
  //             className="button-primary view-btn me-3"
  //             onClick={() =>
  //                 handleViewPayment(row.id, row.payment_mode)
  //             }
  //         >
  //             View
  //         </button>
  //     );
  // }
  function ViewPayment(row) {
    return (
      <>
        {row.invoice_numbers.length > 0 && (
          <button
            type="button"
            className="button-primary view-btn me-3"
            onClick={() =>
              handleViewPayment(
                row.id,
                row.payment_mode,
                row.supplies_receive_id
              )
            }
          >
            View
          </button>
        )}
      </>
    )
  }

  function handleViewPayment(id, payment_mode, supplies_receive_id) {
    if (supplies_receive_id) {
      navigate("/se/paysuppliers/view/" + id + "/" + payment_mode.split(" ")[0])
    } else {
      navigate("/paysuppliers/view/" + id + "/" + payment_mode.split(" ")[0])
    }
  }

  function InvoiceBtn(row) {
    const handleViewInvoice = row.supplies_receive_id
      ? handleViewExpenseInvoice
      : handleViewPurchaseInvoice

    return (
      <ButtonGroup vertical>
        <>
          {row.invoice_numbers?.map((invoiceId) => (
            <button
              key={invoiceId}
              type="button"
              className="button-secondary table-button p-1"
              onClick={() => handleViewInvoice(invoiceId)}
            >
              {`INV.${invoiceId}`}
            </button>
          ))}
        </>
      </ButtonGroup>
    )
  }

  function handleViewPurchaseInvoice(id) {
    window.open("/purchaseinvoices/print/" + id, "_blank")
  }

  function handleViewExpenseInvoice(id) {
    window.open("/se/purchaseinvoices/print/" + id, "_blank")
  }

  function handleAddChange(e) {
    navigate("/paysuppliers/add/" + e.target.value)
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    if (name === "supplier_id") {
      var id = value.split("|")[0]
      var type = value.split("|")[1]
      var by = value.split("|")[2]
      if (by === "supplier") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            supplier: id,
            supplier_id: id,
            vendor_id: "",
            type: type,
          }
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            supplier: "",
            supplier_id: "",
            vendor_id: id,
            type: type,
          }
        })
      }
    } else {
      if (name === "type") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            [name]: value,
            supplier: "",
            supplier_id: "",
            vendor_id: "",
          }
        })
        setSelectedSupplier({
          label: "All Suppliers",
          value: "",
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            [name]: value,
          }
        })
      }
    }
  }

  // EXPORT FUNCTION
  function handleExport() {
    const rows = excelData
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "PaymentList.xlsx", { compression: true })
  }

  useEffect(() => {
    fetchAllSupplierPayments()
  }, [filterConfig])

  useEffect(() => {
    fetchSuppliers()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASE PAYMENTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4 d-flex justify-content-between">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              ISSUED PAYMENTS
            </h1>
          </Col>
          <Col xs={12} lg={3} className="">
            <input
              type="search"
              placeHolder="Search here..."
              className="search-bar"
              onChange={(e) =>
                setFilterConfig((prev) => ({ ...prev, term: e.target.value }))
              }
            />
          </Col>
          {/* <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <Form.Select
                // className="add-select"
                className="me-3 add-type"
                onChange={(e) => handleAddChange(e)}
              >
                <option value="" hidden selected>
                  Add
                </option>
                <option value="bank">Bank to Bank</option>
                <option value="cash">Cash</option>
                <option value="check">Check</option>
                <option value="others">Others</option>
              </Form.Select>
            </div>
          </Col> */}
        </Row>

        <div className="tab-content">
          {/* filters */}
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={6} lg={2} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyle}
                value={selectedSupplier}
                options={suppliers}
                onChange={handleSupplierChange}
              />
            </Col>
            <Col xs={6} lg={2} className="mb-2 mb-lg-0">
              <Form.Select
                name="payment_mode"
                className="date-filter force-width w-full"
                onChange={(e) => handleFilterChange(e)}
                value={filterConfig.payment_mode}
              >
                <option value="" hidden selected>
                  Payment Mode
                </option>
                <option value="">All</option>
                <option value="bank">Bank</option>
                <option value="cash">Cash</option>
                <option value="check">Check</option>
                <option value="other">Other</option>
              </Form.Select>
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                name="from"
                className="date-filter me-4 form-control"
                // placeholderText="Select Date"
                selected={filterConfig.from}
                onChange={(date) => {
                  setDateFrom(Moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, from: date }
                  })
                }}
                placeholderText="Select Date From"
                showYearDropdown
                dateFormat={"MMM dd, yyyy"}
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                name="to"
                className="date-filter ps-label-content me-5 form-control"
                // placeholderText="Select Date"
                selected={filterConfig.to}
                onChange={(date) => {
                  setDateTo(Moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, to: date }
                  })
                }}
                placeholderText="Select Date"
                showYearDropdown
                dateFormat={"MMM dd, yyyy"}
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className=" PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 mt-2 ps-label">
              Total Amount: {summary === 0 ? "0.00" : summary}
            </span>
          </div>
          <div className="mb-2" />
          <div>
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE ISSUED",
                "SUPPLIER",
                "PAYEE",
                "AMT",
                "PYMNT MODE",
                "INVOICES APPLIED",
                "BANK NAME",
                "DATE ADDED",
                // "DOC NO.",
                "DOC No.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "issue_date",
                "supplier",
                "payee",
                "amount",
                "payment_mode",
                "invoice_numbers",
                "bank_name",
                "date",
                // "doc_no",
                "id",
              ]}
              tableData={filteredData}
              ActionBtn={(row) => ActionBtn(row, "pending")}
              ViewBtn={(row) => ViewPayment(row)}
              newTabBtn={(row) => InvoiceBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div className="mb-2" />
        </div>
        <div className="mb-3" />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>

      {/* modals */}
      <Delete
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        text="payment"
        onDelete={handleDeleteSP}
        isClicked={isClicked}
      />
      <GenerateBirModal
        show={showGenerateBirModal}
        hide={() => handleCloseGenerateBirModal()}
        message="Are you sure you want to Generate BIR 2307 for this purchase invoice?"
        handler={() => handleGenerateBir2037()}
        isClicked={isClicked}
      />
      <Footer />
    </div>
  )
}
